import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getLeave(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetAllUserLeave(payload:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLUSERLEAVES+ `?start_date=${payload.startDate}&end_date=${payload.endDate}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getUserWiseDetails(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETUSERBYDEATILSBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLeave(from:string,to:string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLUSERLEAVES + `?start_date=${from}&end_date=${to}`,
      callParams
    );
    //getUserApplyLeaveByIds?start_date=01/09/2023&end_date=15/09/2023
    return response;
  } catch (error) {
    throw error;
  }
}

export async function leaveApprove(
  userId: string,
  id: string,
  status: any
) {
  const body = {
    userId: userId,
    id: id,
    status: status,
  };
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.LEAVEAPPROVE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

